import {memo} from 'react'

import PropTypes from 'prop-types'

import {atomCheckboxSizes} from '@s-ui/react-atom-checkbox'
import Label from '@s-ui/react-atom-label'
import MoleculeSelectOption from '@s-ui/react-molecule-dropdown-option'
import MoleculeSelect, {moleculeSelectDropdownListSizes} from '@s-ui/react-molecule-select'
import IconUnchecked from '@adv-mt/mt-svg-icons/lib/CheckboxEmpty.js'
import IconChecked from '@adv-mt/mt-svg-icons/lib/CheckboxFilled.js'
import IconIndeterminate from '@adv-mt/mt-svg-icons/lib/CheckboxIntermediate.js'
import ChevronDown from '@adv-mt/mt-svg-icons/lib/ChevronDown'
import IconClose from '@adv-mt/mt-svg-icons/lib/Close'

const checkboxProps = {
  checkedIcon: IconChecked,
  indeterminateIcon: IconIndeterminate,
  uncheckedIcon: IconUnchecked,
  size: atomCheckboxSizes.MEDIUM
}

const FormFilterMultiSelect = ({label, options, value = [], placeholder = '', onChange = () => {}}) => {
  const _mapLabelToId = label => {
    const option = options.find(option => label === option.label)
    return option.id
  }

  const _mapIdToLabel = id => {
    const option = options.find(option => String(id) === String(option.id))
    return option?.label
  }

  const _handleOnChange = (ev, {value}) => {
    const valuesObj = value.map(_mapLabelToId)
    onChange(ev, {value: valuesObj})
  }

  const selectValues = value.map(_mapIdToLabel).filter(Boolean)

  return (
    <div className="mt-FormFilterMultiSelect">
      {label && <Label text={label} />}
      <MoleculeSelect
        placeholder={placeholder}
        value={selectValues}
        onChange={_handleOnChange}
        size={moleculeSelectDropdownListSizes.LARGE}
        iconArrowDown={<ChevronDown size="medium" />}
        iconCloseTag={<IconClose size="small" />}
        multiselection
      >
        {options.map(({id, label}) => (
          <MoleculeSelectOption key={id} value={label} checkboxProps={checkboxProps}>
            {label}
          </MoleculeSelectOption>
        ))}
      </MoleculeSelect>
    </div>
  )
}

FormFilterMultiSelect.displayName = 'FormFilterMultiSelect'

FormFilterMultiSelect.propTypes = {
  label: PropTypes.string.isRequired,
  onChange: PropTypes.func,
  options: PropTypes.oneOfType([PropTypes.object, PropTypes.array]).isRequired,
  placeholder: PropTypes.string,
  value: PropTypes.arrayOf(PropTypes.number)
}

export default memo(FormFilterMultiSelect)
